var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mainDiv" } },
    [
      _c("div", { attrs: { id: "headerDiv" } }, [
        _c(
          "div",
          { staticStyle: { width: "50%" } },
          [
            _c("v-text-field", {
              staticStyle: { width: "70%" },
              attrs: {
                label: "Buscar...",
                "single-line": "",
                "hide-details": ""
              },
              on: { input: _vm.handleSearch },
              model: {
                value: _vm.searchReport,
                callback: function($$v) {
                  _vm.searchReport = $$v
                },
                expression: "searchReport"
              }
            })
          ],
          1
        ),
        _c(
          "span",
          { staticStyle: { display: "flex", "justify-content": "flex-end" } },
          [
            _c(
              "v-btn",
              {
                staticClass: "btn-crear",
                attrs: { disabled: _vm.datesHasChange, color: "#FFE700" },
                on: { click: _vm.verModal }
              },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { color: "black" },
                    attrs: { dark: "", left: "" }
                  },
                  [_vm._v("add_circle_outline")]
                ),
                _c("span", { staticStyle: { color: "black" } }, [
                  _vm._v("Crear")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.showButtonInformes
        ? _c("v-flex", {
            staticStyle: {
              display: "flex",
              "align-items": "flex-end",
              "justify-content": "flex-end",
              "max-width": "100%",
              right: "40px"
            },
            attrs: { sm3: "", md3: "" }
          })
        : _vm._e(),
      _c("div", { attrs: { id: "bodyDiv" } }, [
        _c("div", { staticStyle: { height: "100%", width: "100%" } }, [
          _c(
            "div",
            { staticClass: "gridcard rounded-card" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-material",
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "font-family": "'Asap', sans-serif"
                },
                attrs: { gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ])
      ]),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: {
              show: _vm.mostrarModalVerDetalle,
              detalleSeleccionado: _vm.detalleSeleccionado
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }